import React from 'react'
import Productionbox from './Productionbox'
import pimage0 from '../images/gps.png'
import pimage1 from '../images/battery.jpg'
import pimage2 from '../images/MOTOR.png'
import pimage3 from '../images/arduino.png'
import pimage4 from '../images/encoder.png'
import pimage5 from '../images/nano.jpg'
import pimage6 from '../images/ras.png'
import pimage7 from '../images/WHEELS.png'
import pimage8 from '../images/MOTORDRIVE.png'
import pimage9 from '../images/power.png'
import pimage10 from '../images/camera.png'
import pimage11 from '../images/ultrasonic.png'
import pimage12 from '../images/wood.jpg'
import pimage13 from '../images/comp.png'
export default function Products() {
    return (
        <div>

      
      
           <div className="title">
      <br></br>
      <br></br>
      <br></br>
            <h2>Hardware</h2>
    </div>
        
        <div id= 'maindish'>

        <div className='a-container'>
        <Productionbox image={pimage5} title="Jetson Nano"/> 
        <Productionbox image={pimage8} title="Motor Driver"/> 
        <Productionbox image={pimage6} title="Raspberry Pi"/>
        <Productionbox image={pimage3} title="Ardunino UNO"/>
        </div>
        <div className='a-container'>
        <Productionbox image={pimage10} title="Stereo Camera"/>
        <Productionbox image={pimage1} title="Lipo Eternity Battery"/>
        <Productionbox image={pimage9} title="Anker Infinity Core"/>
        <Productionbox image={pimage2} title="Kraken Gear Motor"/>
         
        </div>
        <div className='a-container'>
        <Productionbox image={pimage4} title="Encoder"/>
        <Productionbox image={pimage7} title="Wheels"/> 
        <Productionbox image={pimage0} title="GPS"/>
        <Productionbox image={pimage11} title="Ultrasonic Sensor"/>  
        </div>
        <div className='a-container'>
        <Productionbox image={pimage12} title="Wood"/>
        <Productionbox image={pimage13} title="Assesories"/> 

        </div>


        </div>
        </div>
    )
}
